import React from 'react';
import InProgressIcon from '../../../src/assets/InProgressIcon.png';
import AdjournedIcon from '../../../src/assets/AdjournedIcon.png';
import CompletedIcon from '../../../src/assets/CompletedIcon.png';
import CancelledIcon from '../../../src/assets/CancelledIcon.png';

interface StatusIndicatorProps {
  status: string;
}

const statusIcons: { [key: string]: string } = {
  'In Progress': InProgressIcon,
  Adjourned: AdjournedIcon,
  Completed: CompletedIcon,
  Cancelled: CancelledIcon,
};

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  const imgSrc = statusIcons[status];

  return (
    <div>
      {imgSrc && (
        <img src={imgSrc} alt={`${status} icon`} className="proceeding-list-status-icon" />
      )}
      &nbsp;
      {status}
    </div>
  );
};

export default StatusIndicator;
